import styled from "styled-components";
import {
	Avatar as AntAvatar,
	Input as AntInput,
	Button as AntButton,
	Form as AntForm,
} from "antd";
import { NoImageUser } from "@assets";

export const RootContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	margin: 0 16px;
	min-height: calc(100vh - 70px);
	gap: 32px;
	overflow: hidden;
`;

export const AvatarWrapper = styled.div`
	margin: 16px 0 0;
`;

export const Avatar = styled(AntAvatar)`
	border-radius: 12px !important;
`;

export const ProfileInputContainer = styled.div`
	position: absolute;
	bottom: ${(props) => (props.isImg ? "-18px" : "-12px")};
	left: 0px;
	width: 120px;
	height: 28;
	border-radius: 0px 0px 12px 12px;
	display: flex;
	justify-content: center;
	align-items: center;
`;
// export const Form = styled(AntForm)`
//   .ant-form-item-explain {
//     text-align: left; /* align warning text to the left */
//     margin-left: 24px !important;
//   }

//   .ant-form-item {
//     margin: 0px 0 24px 0;
//   }
// `

export const InputLabel = styled.p`
	position: absolute;
	left: 24px;
	top: -8px;
	z-index: 30;
	margin: 0px;
	padding: 0px 4px;
	color: #535b5d;
	background-color: white;
	font-family: Plus Jakarta Sans;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

// export const Input = styled(AntInput)`
//   height: 52px;
//   text-align: center;
//   border-radius: 34px;
//   border: 1.5px solid #DEDEDE;
//   background: #FFF;
//   -webkit-text-fill-color: ${props => props.disabled ? "#ABABAB" : '#181E1F'} !important ;
//   text-align: left;
//   padding: 0 0 0 24px;
//   color: ${props => props.disabled ? "#ABABAB" : '#181E1F'} !important ;
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: normal;

//   input{
//     text-align: left;
//     color: ${props => props.disabled ? "#ABABAB" : '#181E1F'} !important ;
//   }
// `;

export const Input = styled(AntInput)`
	border-radius: 8px;
	border: none;
	height: 52px;
	/* background-color: ${(props) =>
		props.inputType === "phone" ? "#1E1A1B !important" : "#050508"}; */
	/* color: ${(props) =>
		props.inputType === "phone" ? "#535353 !important" : "white"}; */
	background-color: #e5e0f5 !important;
	color: #000000 !important;

	font-size: 16px !important ;
	font-weight: 500;
	line-height: 22.5px;

	.ant-input {
		font-size: 17px !important;
	}

	/* &:hover {
		border: 1px solid #212224 !important;
	} */

	.ant-input::placeholder {
		color: #686b6e;
		font-weight: 200;
		font-size: 18px;
	}

	&&& {
		padding-left: 24px;
	}
	/* &:focus {
		border: ${(props) =>
		props.inputType === "phone"
			? "1.5px solid #212224"
			: "1.5px solid #FFC654"} !important;
		box-shadow: none;
	} */
`;

export const PhoneNumberWrapper = styled.div`
	background-color: #161719;
	font-size: 18px;
	font-weight: 400;
	line-height: 22.5px;
	color: #424242;
	height: 54px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	padding-left: 24px;
`;

export const FileInput = styled.input`
	display: none;
`;

export const SaveButton = styled(AntButton)`
	box-sizing: border-box !important ;
	width: calc(100%) !important;
	height: 52px;
	margin: 25px 15px 20px;
	border-radius: 12px !important;
	background-color: #49028e !important;
	color: #ffffff !important;
	font-family: Plus Jakarta Sans;
	font-size: 20px !important;
	font-style: normal;
	font-weight: 700 !important;
	line-height: normal;
	&:hover {
		background-color: #49028e !important;
		color: #ffffff !important;
	}
`;

export const NoImageIcon = styled.img.attrs({
	src: `${NoImageUser}`,
	alt: "no_img",
})`
	margin-top: 4px;
	width: 73px;
	height: 73px;
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
		color: #5d5189;
		font-size: 13px;
		font-weight: 600;
		line-height: 17.5px;
		display: flex;
		margin-left: 18px;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const Phone = styled.span`
	color: ${(props) => (props.text ? "#5d5189" : "#9B92BB")};
	font-size: 14px;
	font-weight: 400;
	line-height: 21.17px;
`;

export const PhoneWrapper = styled.div`
	margin-top: 8px;
`;
